export default __webpack_public_path__ + "static/media/tournament.6a3bcb6b.png";